import { gsap } from 'gsap'
import { ScrollTrigger, ScrollToPlugin } from 'gsap/all'
import { useStateListen } from '../modules/_fn'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)


// header 往下滾動收合 往上滾動出現
const useHeaderSticky = () => {
  const header = document.querySelector('header.header')

  gsap.timeline({
    scrollTrigger: {
      trigger: 'main',
      start: 'top top',
      end: 'max',
      scrub: true,
      onUpdate: (e) => {
        const { scrollTop } = document.scrollingElement
        const headerHeight = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
        if (scrollTop > headerHeight) {
          header.classList.add('is-fixed')
        }
        else {
          header.classList.remove('is-fixed')
        }
        if (!header.classList.contains('is-fixed')) return;

        const { direction } = e
        if (direction < 0) {
          header.classList.add('is-show')
        }
        if (direction > 0) {
          header.classList.remove('is-show')
          setIsMenuOpen(false)
        }
      }
    }
  })
}

// menu 點擊開關
const useMenuEffect = (isMenuOpen) => {
  const menu = document.querySelector('.menu')
  const menuIcon = document.querySelector('.menu-icon')
  if (!menu || !menuIcon) return;
  if (isMenuOpen) {
    menu.classList.add('is-show')
    menuIcon.classList.add('is-active')
  }
  else {
    menu.classList.remove('is-show')
    menuIcon.classList.remove('is-active')
  }
}

const [isMenuOpen, setIsMenuOpen] = useStateListen(false, useMenuEffect)

const useMenuControl = () => {
  const menu = document.querySelector('.menu')
  const menuBtn = document.querySelector('.menu-icon')
  if (!menu || !menuBtn) return;

  menuBtn.addEventListener('click', () => {
    setIsMenuOpen(prev => !prev)
  })
}

//
const useHeaderAnchor = () => {
  const triggers = [...document.querySelectorAll('[data-anchor]')]
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const attr = trigger.getAttribute('data-anchor')
      if (!attr.includes('channels')) return;

      const target = document.querySelector(attr)
      if (target) {
        gsap.to(window, { duration: 1, scrollTo: target });
      }
      if (!target) {
        window.location.href = './index.html#channels';
      }
    })
  })

  const autoAnchor = () => {
    const { href } = window.location
    const target = document.querySelector('section.channels')
    // console.log('%cheader.js line:90 href', 'color: #007acc;', href, href.includes('#channels'));
    if (href.includes('#channels')) {
      gsap.to(window, { duration: 1, scrollTo: target, delay: 1 });
    }
  }

  autoAnchor()
}


export {
  useHeaderSticky,
  useMenuControl,
  useHeaderAnchor
}